import { useCallback, useEffect, useMemo, useState } from 'react';
import { BzButton, BzCard, BzChip, BzInputText } from '../../../../../components';
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getFormattedNumbers, getMktSegIdFromApiExchangeName, handlePositionsChange,setStorageWithMultiTabCheckWithoutEncryption } from '../../../../../utils/global_functions';
import { useWFHMessages } from '../../../../../hooks';
import { getWfhTouchlineLastTick } from '../../../../../redux/actions/wfh';
import { sendTouchlineRequest } from '../../../../../apis/web_socket';
import { FILTER_DISPLAY_OPTIONS, SESSION_STORAGE_KEYS, TL_INDEX } from '../../../../../utils/global_variables';
import { Link, useNavigate } from 'react-router-dom';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import { updateFilters } from '../../../../../redux/actions/orders';
import ZeroStates from '../../../../ZeroStates';
import { positionsFilter } from '../../../../../controllers/netPosition';
import moment from 'moment';


const Todays = ({ handlePlaceOrder }) => {


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const todaysPostions = useSelector(state => state?.netPosition?.todaysPostions);
    const modalData = useSelector(state => state.modals?.modalData);
    const objFilterData = useSelector(state => state?.orders?.objFilterData);

    const [searchText, setSearchText] = useState();
    const [isSearchShoing, setIsSearchShowing] = useState(true);
    const [todayData, setTodayData] = useState([]);


    // const activeNetPositions = useSelector(state => state.netPosition.activeNetPositions);

    useEffect(() => {
        if (todaysPostions?.length > 0) {
            let arrScrips = todaysPostions?.map((each) => ({
                exchangeId: getMktSegIdFromApiExchangeName(each?.preferred_exchange),
                token: each?.preferred_scrip_token,
                isSubscribe: true
            }));
            sendTouchlineRequest(arrScrips);
        }
        return () => {
            if (todaysPostions?.length > 0) {
                let arrScrips = todaysPostions?.map((each) => ({
                    exchangeId: getMktSegIdFromApiExchangeName(each?.preferred_exchange),
                    token: each?.preferred_scrip_token,
                    isSubscribe: false
                }));
                sendTouchlineRequest(arrScrips);
            }
        };
    }, [todaysPostions]);



    useEffect(() => {
        setTodayData(todaysPostions);
    }, [todaysPostions]);
    // Azeem K : 01-04-2024 : BT-102298  Netposition Optamization – Start 
    const objTodaysPositionsIndexes = useSelector(state => state?.netPosition?.objTodaysPositionsIndexes);
    // Azeem K : 01-04-2024 : BT-102298  Netposition Optamization – End 
    const handleTodayPositions = useCallback((arrTouchLineData) => {
        let data = todayData;
        // Azeem K : 01-04-2024 : BT-102298  Netposition Optamization – End 
        const arrMatchedPositions = objTodaysPositionsIndexes[arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN]];
        if (arrMatchedPositions?.length > 0) {
            arrMatchedPositions?.forEach((nEachIndex) => {
                const positionsData = handlePositionsChange(todaysPostions[nEachIndex], arrTouchLineData);
                data[nEachIndex] = positionsData;
                setTodayData([...data]);
                // Azeem K : 01-04-2024 : BT-102298  Netposition Optamization – End 
            });
        }
    }, [todaysPostions, todayData]);

    useWFHMessages('touchline', (e) => {
        handleTodayPositions(e.detail);
    });

    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        if (Object.keys(objLastTickData).length > 0) {
            if (todaysPostions?.length > 0) {
                todaysPostions?.forEach((each) => {
                    const arrLastTickData = objLastTickData[each?.segment_id_token];
                    if (arrLastTickData?.length > 0) {
                        handleTodayPositions(arrLastTickData);
                    }
                });
            }
        }
    }, [todaysPostions, dispatch]);

    const onSearchChange = (value) => {
        setSearchText(value);
    };

    const onSearchClose = () => {
        setSearchText();
        setIsSearchShowing(true);
    };


    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -start
    const filteredData = useMemo(() => {
        if (modalData?.filter !== undefined) {
            if (Object?.keys(modalData?.filter)?.length > 0) {
                let filteredArray = positionsFilter(modalData?.filter, todayData);
                if (searchText?.length > 0) {
                    filteredArray = filteredArray?.filter((each) => each.title.toLowerCase().includes(searchText.toLowerCase()));
                }
                return filteredArray;
            } else { }
        } else { }
        if (todayData?.length > 0) {
            if (searchText?.length > 0) {
                const filteredPositions = todayData?.filter((each) => each.title.toLowerCase().includes(searchText.toLowerCase()));
                return filteredPositions;
            } else {
                return todayData;
            }
        } else { }
    }, [searchText, modalData, todayData]);
    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -end

    //Vaibhav SIngh: 08-03-24: todaysData updated : Start
    const totalTodaysBuyValue = todayData?.reduce((acc, item) => acc + (parseFloat(item?.cf_buy_value) === 0 ? parseFloat(item?.buy_value) : parseFloat(item?.cf_buy_value)), 0)?.toFixed(2);
    const totalTodaysSellValue = todayData?.reduce((acc, item) => acc + (parseFloat(item?.cf_sell_value) === 0 ? parseFloat(item?.sell_value) : parseFloat(item?.cf_sell_value)), 0)?.toFixed(2);
    // const totalNetvalue = todayData?.reduce((acc, item) => acc + ((parseFloat(item?.cf_buy_value) == 0 ? parseFloat(item?.buy_value) : parseFloat(item?.cf_buy_value)) - (parseFloat(item?.cf_sell_value) == 0 ? parseFloat(item?.sell_value) : parseFloat(item?.cf_sell_value))), 0)?.toFixed(2);
    const RealisedPL = todayData?.reduce((acc, item) => acc + (parseFloat(item?.realised_pl)), 0)?.toFixed(2);
    const unRealisedPl = todayData?.reduce((acc, item) => acc + (parseFloat(item?.unrealised_pl)), 0)?.toFixed(2);
    //  Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -Start
    //  Dont remove code it may be require later 
    // const realisedPercentageChange = postionOverviewPercentageChange(RealisedPL, totalNetvalue);
    // const unRealisedPercentageChange = postionOverviewPercentageChange(unRealisedPl, totalNetvalue);
    //  Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -End
    //Vaibhav SIngh: 08-03-24: todaysData updated : End
    const allProductType = [...new Set(todaysPostions.map(element => element.product_type))];
    //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : Start
    const handleFilters = () => {
        if (todaysPostions?.length) {
            let segemntList = [];
            segemntList.push('All', 'All Combined');
            for (let c = 0; c < todaysPostions.length; c++) {
                if (segemntList.indexOf(todaysPostions[c].customSegment) === -1) {
                    segemntList.push(todaysPostions[c].customSegment);
                } else { }
            }
            dispatch(handleModal([{ "FILTER_ORDER_POSITION_MODAL": true }]));
            dispatch(handleModalData({ type: 'Positions', allProductType: allProductType, segemntList: segemntList }));
        }
    };

    const handleOrderHistory = (id) => {
        const path = `/orders?section=netPosition_Today`;
        navigate(path, { state: id });
        setStorageWithMultiTabCheckWithoutEncryption(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    };
    const handleClickChips = (ele) => {
        delete objFilterData[ele];
        dispatch(handleModalData({ filter: objFilterData }));
        dispatch(updateFilters(objFilterData));
    };
    return (
        <>
            <Container fluid className='p-0 px-3'>
                <Row className='g-0 py-1 mb-2 align-items-center h_40'>
                    <Col md={4} className={`d-flex justify-content-start align-items-center ${todaysPostions?.length < 1 ? 'div-disabled' : ''}`}>
                        <Link to='/orders?section=squareOfftodays'>
                            <BzButton className='btn btn-sm btn-outline'>Square off All</BzButton>
                        </Link>
                    </Col>
                    <Col md={8} className='d-flex justify-content-end align-items-center'>
                        {isSearchShoing === true ?
                            <div onClick={() => todayData?.length > 0 ? setIsSearchShowing(false) : null} className={`icon-16 icon-search ${todayData?.length > 0 ? 'icon-dark' : 'icon-grey'}`}></div>
                            : <>
                                <div className='position-relative w-70'>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText autoFocus onChange={(e) => onSearchChange(e.target.value)} size='sm' type='search' placeholder="Search Scrips" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                </div>
                                <div className='icon-16 icon-dark icon-close ms-2 flex-shrink-0' onClick={() => onSearchClose()} />
                            </>
                        }
                        <div className={`icon-16 icon-searchfilter flex-shrink-0 ${todaysPostions?.length ? 'icon-dark' : 'icon-grey'} ms-3`} onClick={handleFilters}></div>
                        <Link to='/orders?section=netPosition_Today'>
                            <div className='icon-14 icon-redirect flex-shrink-0 icon-dark ms-3'></div>
                        </Link>
                    </Col>
                </Row>
                {Object.keys(objFilterData)?.length ?
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex'>
                            <div className='font-medium font-size3 color-text m-1'>Filters:</div>
                            <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                {/*Vaibhav singh:15-03-24: Chips Class Updated : Start */}
                                {Object.keys(objFilterData)?.map((ele, i) => {
                                    return <div key={i} className='chips chips default-chip text-capitalize m-1'>
                                        {objFilterData[ele] === "low_high" ? `${ele} : Low-High` : objFilterData[ele] === "high_low" ? `${ele} : High-Low` : parseFloat(objFilterData[ele]) ? `${ele.slice(-3)} : ${objFilterData[ele]}` : `${FILTER_DISPLAY_OPTIONS?.[ele] ? FILTER_DISPLAY_OPTIONS?.[ele] : ele} : ${objFilterData[ele]}`} <div style={{ width: "6px", height: '6px', marginLeft: "6px" }} onClick={handleClickChips?.bind(this, ele)} className='icon-16 icon-dark icon-close'></div>
                                    </div>;
                                })
                                }
                            </div>
                        </Col>
                    </Row>
                    : null
                }
                {/* //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : Start */}
            </Container>
            {todayData?.length > 0 ?
                <Container fluid className='p-0'>
                    <div className='sticky-positions-height px-3'>
                        <Row className='g-0 order-position-card-wrapper p-3 mb-2'>
                            <Row className='g-0 mb-3'>
                                <Col>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Total Buy Value</div>
                                    <div className='font-medium font-size4 color-text'>&#8377;{getFormattedNumbers(totalTodaysBuyValue)}</div>
                                </Col>
                                <Col className='text-end'>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Total Sell Value</div>
                                    <div className='font-medium font-size4 color-text'>&#8377;{getFormattedNumbers(totalTodaysSellValue)}</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Realised P/L</div>
                                    <div className={`font-medium font-size3 color-text ${RealisedPL > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(RealisedPL)}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -Start
                                         Dont remove code it may be require later  */}
                                        {/* ({realisedPercentageChange > 0 ? '+' : ''}{realisedPercentageChange}%) */}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -End */}
                                    </div>
                                </Col>
                                <Col className='text-end'>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Unrealised P/L</div>
                                    <div className={`font-medium font-size3 color-text ${unRealisedPl > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(unRealisedPl)}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -Start
                                         Dont remove code it may be require later  */}
                                        {/* ({unRealisedPercentageChange > 0 ? '+' : ''}{unRealisedPercentageChange}%) */}
                                    </div>
                                </Col>
                            </Row>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                <div className='p-0'>
                                    <div className='transparent-card-wrap'>
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - Start*/}
                                        {filteredData.length > 0 ? filteredData?.map((each, i) => (
                                            <>
                                                <BzCard key={i} className='transparent-card cursor-pointer bdr-btm' onClick={() => handleOrderHistory(each?.id)}>
                                                    <Row className='g-0 mb-1'>
                                                        <Col className='d-flex justify-content-start align-items-center'>
                                                            <div className='font-medium font-size3 color-text text-uppercase me-2'>{each?.title}</div>
                                                            {/* Vaibhav Singh: 20-02-24: Fixed issue with series: Start */}
                                                            <div className='d-flex'>
                                                                {
                                                                    (each?.expiry_date && each?.strike_price && each?.strike_price > 0 &&
                                                                        each?.instrument) ?
                                                                        <div className='font-regular font-size2 color-subtext'>{`${moment(each?.expiry_date).format("DDMMMYYYY").toUpperCase().slice(0, 2)}  ${moment(each?.expiry_date).format("DDMMMYYYY").toUpperCase().slice(2, 5)} ${each?.strike_price} ${each?.option_type} `}</div> //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                                                                        : (!each?.expiry_date && (!each?.strike_price || each?.strike_price <= 0) &&
                                                                            !each?.option_type) ?
                                                                            <div className='d-flex align-items-center'><div className='font-regular font-size2 color-subtext'>{each?.series}</div></div> //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                                                                            : (each?.expiry_date && (!each?.strike_price || each?.strike_price <= 0)) ?
                                                                                <div className='font-regular font-size2 color-subtext'>{`${moment(each?.expiry_date).format("DDMMMYYYY").toUpperCase().slice(0, 2)} ${moment(each?.expiry_date).format("DDMMMYYYY").toUpperCase().slice(2, 5)} ${each?.instrument?.slice(0, 3)} `}</div> //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                                                                                : null
                                                                }
                                                            </div>
                                                            {/* Vaibhav Singh: 20-02-24: Fixed issue with series: End */}
                                                            {/* <div className='d-flex align-items-center'>
                                                                {dontMissData?.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each?.segment_id_token)
                                                                    ?
                                                                    <div className='icon-16 icon-dontmiss icon-yellow float-start ms-2'></div> : null} */}
                                                            {/* {(holdingsScrips?.some(element => element?.nMarketSegmentId + '_' + element?.nToken === each?.segment_id_token) ?
                                                                    <div className='icon-16 icon-portfolio icon-dark ms-2'></div> : null)}
                                                            </div> */}
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0 mb-1'>
                                                        <Col className='d-flex justify-content-start'>
                                                            <div className='font-regular font-size2 color-text'>
                                                                <span className={`font-medium color-text ${each?.buy_quantity > each?.sell_quantity ? 'color-positive' : 'color-negative'}`}>{each?.buy_quantity > each?.sell_quantity ? 'BUY' : 'SELL'}: </span>{each?.net_quantity} Qty @ ₹{each?.net_price}
                                                            </div>
                                                        </Col>
                                                        <Col className='d-flex justify-content-end'>
                                                            <div className='font-regular font-size2 color-text text-end'>
                                                                <span className='color-subtext'>LTP: </span> {each?.ltp}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0'>
                                                        <Col md={4} className='d-flex justify-content-start align-self-center'>
                                                            <div className='chips-wrap'>
                                                                <BzChip className='chips primary-chip text-capitalize'>{each?.product_type}</BzChip>
                                                            </div>
                                                        </Col>
                                                        <Col md={8} className='d-flex justify-content-end align-self-center'>
                                                            <div className='font-regular font-size2 color-text text-end'>
                                                                <span className='color-subtext'>Today P/L: </span> <span className={`${parseFloat(each?.todays_pl) > 0 ? 'color-positive' : 'color-negative'}`}>{parseFloat(each?.todays_pl) > 0 ? '+' : ''}{each?.todays_pl}({parseFloat(each?.profit_loss) > 0 ? '+' : ''}{parseFloat(each?.profit_loss).toFixed(2)}%)</span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </BzCard>
                                            </>
                                        )) :
                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                            </div>
                                        }
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - End*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
                :
                <div className='zero-state-alerts zero-state-alerts-lg'>
                    <ZeroStates handleOnClick={handlePlaceOrder} subText="No Positions available" icon='icon-64 icon-nodata mb-3 mrgauto' btnText="Take a position today. Place an order." btnClass='btn btn-md btn-outline mt-2' />
                </div>
            }
        </>
    );
};

export default Todays;
